import { getColor } from '../../../../theme-tools';
var parts = ['container', 'groupTitle', 'item', 'itemEmpty'];
var baseStyle = props => {
  var {
    theme
  } = props;
  return {
    container: {
      _focusVisible: {
        boxShadow: "0 0 0 3px ".concat(getColor(theme, 'yellow.200')),
        outline: 'none'
      }
    },
    groupTitle: {
      bg: 'white',
      lineHeight: 'base'
    },
    item: {
      bg: 'white',
      _hover: {
        bg: 'blue.1140',
        _active: {
          bg: 'blue.1140'
        }
      },
      _active: {
        bg: 'blue.1140'
      },
      '.tqc-radio__inner-container': {
        p: 0,
        bg: 'transparent',
        _hover: {
          bg: 'transparent'
        }
      }
    }
  };
};
export var Listbox = {
  parts,
  baseStyle
};